module.exports = __webpack_public_path__ + "img/blueback.6c4fdaf2.png";